import { checkIsNative } from '../validators';
import { ENativeProjectEnvironment, EProjectEnvironment, IBaseConfigs } from './types';

const configs: IBaseConfigs = __WEB__ ? require('./web').default : require('./native').default;

export default configs;

export const isSIT = (environment?: string) => {
  if (checkIsNative()) {
    return environment === ENativeProjectEnvironment.SIT || environment === ENativeProjectEnvironment.RELEASE_SIT;
  } else {
    return PROJECT_ENV === EProjectEnvironment.SIT || PROJECT_ENV === EProjectEnvironment.RELEASE_SIT;
  }
};

export const isUAT = (environment?: string) => {
  if (checkIsNative()) {
    return environment === ENativeProjectEnvironment.UAT;
  } else {
    return PROJECT_ENV === EProjectEnvironment.UAT;
  }
};

export const isPROD = (environment?: string) => {
  if (checkIsNative()) {
    return environment === ENativeProjectEnvironment.PROD;
  } else {
    return PROJECT_ENV === EProjectEnvironment.PROD;
  }
};

export * from './types';
